var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82498 0.484691C2.17873 -0.161563 1.13094 -0.161564 0.484691 0.48469C-0.161563 1.13094 -0.161563 2.17873 0.484691 2.82498L7.65971 10L0.484691 17.175C-0.161563 17.8213 -0.161564 18.8691 0.48469 19.5153C1.13094 20.1616 2.17873 20.1616 2.82498 19.5153L10 12.3403L17.175 19.5153C17.8213 20.1616 18.8691 20.1616 19.5153 19.5153C20.1616 18.8691 20.1616 17.8213 19.5153 17.175L12.3403 10L19.5153 2.82498C20.1616 2.17873 20.1616 1.13094 19.5153 0.484691C18.8691 -0.161562 17.8213 -0.161563 17.175 0.484691L10 7.65971L2.82498 0.484691Z",
    fill: "#DBEDE7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisabled);
export default __webpack_public_path__ + "static/media/icon_disabled.df44385f6bc316eb35e08cf29fd757a9.svg";
export { ForwardRef as ReactComponent };